module.exports = __webpack_public_path__ + "static/media/coin_ver2_02.cbc1ed66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coin_ver2_02.png
// module id = 298
// module chunks = 57